import { Observable } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { Store } from '@ngrx/store'

import { authSelectors } from '../auth/auth.selectors'
import { AppState } from '../core.state'

export function PlatformInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const store = inject(Store<AppState>)

  return store.select(authSelectors.selectMember).pipe(
    take(1),
    switchMap((token) => {
      if (token && req.url.includes(environment.backendApiUrl)) {
        const clonedReq = req.clone({
          setHeaders: {
            'x-platform': 'CF'
          }
        })

        return next(clonedReq)
      }

      return next(req)
    })
  )
}
